import packageJson from '../../package.json';

// Host URL for API
// export const APIS_URL = 'https://host.simplyhalls.co.uk/';
export const APIS_URL = process.env.REACT_APP_API_URL;

// Any other constants, e.g., API keys, etc.
export const API_KEY = process.env.REACT_APP_API_KEY;

// Additional configuration values
export const DEFAULT_LANGUAGE = 'en';
export const SITE_NAME = 'Simply Halls';

// Payment Booking Fee
export const BookingFee = process.env.REACT_APP_BOOKING_FEE;

// Server URL 
export const ServerURL = process.env.REACT_APP_SERVER_URL;
export const REACT_APP_SOCKET_SERVER_URL = process.env.REACT_APP_SOCKET_SERVER_URL;

// Payment Gateway Redirect URL
export const Payment_Redirect_URL = process.env.REACT_APP_PAYMENT_REDIRECT_URL;


// Socket.io connection URL
export const SOCKET_IO_URL = process.env.REACT_APP_SOCKET_IO_URL;

// Customer Token
export const CUSTOMER_TOKEN = process.env.REACT_APP_CUSTOMER_TOKEN;

export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const FACEBOOK_URL = process.env.REACT_APP_FACEBOOK_URL;

export const INSTAGRAM_URL = process.env.REACT_APP_INSTAGRAM_URL;

export const X_URL = process.env.REACT_APP_X_URL;

export const REVOLUT_MODE = process.env.REACT_APP_REVOLUT_MODE || 'sandbox';

export const REVOLUT_PUBLIC_TOKEN = process.env.REACT_APP_REVOLUT_PUBLIC_TOKEN || '';

// The business clock. Mirrors BUSINESS_TIMEZONE on the host side, and exists for the same reason:
// a stored booking time is wall-clock digits, so working out whether something is due needs a
// "now" expressed on the same clock. Naming the zone handles BST and GMT by itself — there are no
// daylight-saving dates to maintain here or anywhere else.
export const BUSINESS_TIMEZONE = process.env.REACT_APP_BUSINESS_TIMEZONE || 'Europe/London';

export const APP_VERSION = packageJson.version;
